import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditProjectMeter = ({meterId, list}) => {
    const [meterData, setMeterData] = useState(null);
    const [meterType, setMeterType] = useState(''); // State to track selected meter type

    const fetchProjectMeter = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/project_meter/${Id}`)
            .then(response => {
                setMeterData(response.data.data);
                setMeterType(response.data.data.meter_type);
            })
            .catch(error => {
                console.log(error);
                setMeterData([]); 
            });
    }

    useEffect(() => {
        if (meterId) {
            fetchProjectMeter(meterId);
        }
    },[meterId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        meter_type: Yup.string().required('meter type is a required field'),
        price: Yup.number().required('price is a required field').typeError('price must be a number')        
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (meterData) {
            reset(meterData);
            setMeterType(meterData.meter_type);
        }
    }, [meterData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/project_meter/${meterId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_project_meter_${meterId}`);
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
                console.error('Error updating project meter', data);
            });
    }

    const handleMeterTypeChange = (event) => {
        setMeterType(event.target.value);
    };

    if (!meterId || !meterData) {
        return null;
    }

    return (
        <div id={`edit_project_meter_${meterId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Project Meter</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" value={meterData.channel} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" value={meterData.client} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" value={meterData.project} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Meter Type <span className="text-danger">*</span></label>
                                        <div className="radio">
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="radio" value="1" {...register('meter_type')} 
                                                    checked={meterType === '1'} onChange={handleMeterTypeChange}/> Hourly
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="radio" value="0" {...register('meter_type')} 
                                                    checked={meterType === '0'} onChange={handleMeterTypeChange}/> Fixed
                                            </label>
                                        </div>
                                        <div className="text-sm text-danger">
                                            {errors.meter_type && <p>{errors.meter_type.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Meter <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" value={meterData.meter} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">{meterType === '1' ? 'Hourly' : 'Fixed'} Price 
                                            (<i className="fa-solid fa-dollar-sign"></i>) <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={meterData.price}{...register('price')}/>
                                        <div className="text-sm text-danger">
                                            {errors.price && <p>{errors.price.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description</label>
                                        <textarea className="form-control" type="text" defaultValue={meterData.description || ''} {...register('description')}/>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditProjectMeter
